'use strict'

var findOrAddOne = require('./helpers/find-or-add-one')
var findOrAddMany = require('./helpers/find-or-add-many')

module.exports = findOrAdd

/**
 * tries to find object in local database, otherwise creates new one
 * with passed properties.
 *
 * @param  {String}        prefix       optional id prefix
 * @param  {String|Object} idOrObject   id or object with `._id` property
 * @param  {Object}        [properties] Optional properties if id passed
 *                                      as first option
 * @return {Promise}
 */
function findOrAdd (state, prefix, idOrObjectOrArray, newObject) {
  return Array.isArray(idOrObjectOrArray)
    ? findOrAddMany(state, idOrObjectOrArray, prefix)
    : findOrAddOne(state, idOrObjectOrArray, newObject, prefix)
}



//////////////////
// WEBPACK FOOTER
// ./~/pouchdb-hoodie-api/lib/find-or-add.js
// module id = 408
// module chunks = 7